import React, { useEffect, useState } from 'react';

import _ from 'lodash';

import { AssetViewer } from '../../AssetViewer';
import { EmbedContext, WidgetsContext } from '.';

const ContentContext = React.createContext({
  debug: false,
  fetchMappingsForContentGrid: (contentGrid, page, limit) => { },
  fetchPreviewDataForAsset: (asset) => { },
  updateFiltersInContenGrid: (contentGrid, filters) => { },
  updateQueryInContenGrid: (contentGrid, query) => { },
  resetFiltersInContenGrid: (contentGrid) => { },
  viewContent: (widget, content) => { },
  onContentChange: (contentGrid, content) => { },
  onDownload: (asset) => { }
});

const ContentManager = ({
  initialAsset,
  page,
  children,
  fetchMappingsForContentGrid,
  fetchPreviewDataForAsset,
  updateFiltersInContenGrid,
  updateQueryInContenGrid,
  resetFiltersInContenGrid,
  onContentChange,
  onAnalyticsChange,
  onDownload,
  onClose,
  debug
}) => {
  const [assetViewer, setAssetViewer] = useState(null);

  const context = React.useContext(WidgetsContext);

  const embedContext = React.useContext(EmbedContext);

  const domain = context.domain;

  useEffect(() => {
    setAssetViewer(initialAsset);
  }, []);

  const handleViewContent = (widget, content) => {
    if (!content) {
      return;
    }

    if (embedContext.embedded) {
      if (!content.url) {
        return;
      }
      const currentWindow = window.self || window;
      const pageUrl = `${domain}${content.url}?page=${page}&contentGrid=${widget}`;

      var isInIframe = currentWindow.parent !== window;
      if (isInIframe) {
        const parentWindow = window.parent;
        parentWindow.postMessage({
          type: "cleverstory:embed:assetViewer",
          payload: {
            pageUrl: pageUrl,
          }
        }, '*');
      }
      return;
    }

    switch (content.type) {
      case 'INTERACTIVE_CONTENT':
      case 'LANDING_PAGE':
      case 'RESOURCE_CENTER': {
        if (!content.url) {
          return;
        }

        const pageUrl = `${domain}${content.url}`;
        window.open(pageUrl);
        break;
      }
      case 'ASSET': {
        setAssetViewer({
          asset: content,
          contentGrid: widget
        });
        break;
      }
    }
  }

  const handleCloseViewer =()=>{
    setAssetViewer(null);
    var isInIframe = window.parent !== window;
    if (isInIframe) {
      const parentWindow = window.parent;
      parentWindow.postMessage({
        type: "cleverstory:close:assetViewer",
      }, '*');
    }

    if (onClose) {
      onClose()
    }
  }

  const contentContextValue = React.useMemo(() => ({
    debug: debug,
    initialAsset: initialAsset,
    fetchMappingsForContentGrid: fetchMappingsForContentGrid,
    fetchPreviewDataForAsset: fetchPreviewDataForAsset,
    updateFiltersInContenGrid: updateFiltersInContenGrid,
    updateQueryInContenGrid: updateQueryInContenGrid,
    resetFiltersInContenGrid: resetFiltersInContenGrid,
    viewContent: handleViewContent,
    onContentChange: onContentChange,
    onAnalyticsChange: onAnalyticsChange,
    onDownload: onDownload
  }), [debug]);

  return (
    <ContentContext.Provider value={contentContextValue}>
      {children}
      {assetViewer &&
        <AssetViewer
          contentGrid={assetViewer.contentGrid}
          show={true}
          initialContent={_.get(assetViewer, 'asset')}
          debug={debug}
          onClose={handleCloseViewer}
        />
      }
    </ContentContext.Provider>
  );
}

const Content = {
  Manager: ContentManager,
  Context: ContentContext
}

export default Content;
